import { render, staticRenderFns } from "./Welfare.vue?vue&type=template&id=339e7c6e&scoped=true"
import script from "./Welfare.vue?vue&type=script&lang=js"
export * from "./Welfare.vue?vue&type=script&lang=js"
import style0 from "./Welfare.vue?vue&type=style&index=0&id=339e7c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339e7c6e",
  null
  
)

export default component.exports